import React, { PureComponent } from 'react';
import {
    Card, CardBody, Col, Button, ButtonToolbar, Progress
} from 'reactstrap';
import { reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { check, updateGeologiaShapeFile } from "../../Services/GeologiaShapeFileService";
import { checkKey } from "../../Services/SecurityService";
//import {  } from "../../Services/GeometryShapes";
import { FullWideNotification } from '../../../shared/components/Notification';
import NotificationSystem from 'rc-notification';
import { util } from "../../../shared/util";
import shp from "shpjs";

let notificationTC = null;

let cidadesFiles = {};
let geologias2 = [];
let shapeFile = [];
let totalGeologias = 0;
let contGeologias = 0;
const LIMITE = 100;


const rootGeologias = `${process.env.PUBLIC_URL}/19/shp/geologias/`;

class CrudEdit extends PureComponent {
    static propTypes = {
        t: PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            carregarShapes: true,
            next: true,
            clicked: false,

            canceled: false,

            processingStatus: 0,
            processingStatusInfo: 1,
            tempoRestante: '',

            cidades: {},
            files: [],
            geologies: [],

            data: {
                id: '',
                simb1000: '',
                name: '',
                agrLITD: '',
                classe1: '',
                classe2: '',
                clIdLITO: '',
                codUnMET: '',
                codUnPLO: '',
                eonIdMAX: '',
                eonIdMIN: '',
                epcIdMAX: '',
                epcIdMIN: '',
                eraIdMAX: '',
                eraIdMIN: '',
                errIdMAX: '',
                errIdMIN: '',
                hierarquia: '',
                idadeMAX: '',
                idadeMIN: '',
                legMAPA1: '',
                legMAPA2: '',
                lito1: '',
                lito2: '',
                metodoMAX: '',
                metodoMIN: '',
                nomeUNID: '',
                provincia: '',
                qdeInMAX: '',
                qdeInMIN: '',
                simbNEOP: '',
                sisGcMAX: '',
                sisGcMIN: '',
                sisIdMAX: '',
                sisIdMIN: '',
                subClasse1: '',
                subClasse2: '',
                description: '',
                photo: '',
                bibliografia: '',
                color: '#87CEFA',
                colorRGB: { r: 135, g: 206, b: 250, a: 1 },
                status: "ATIVO",
                deleted: false,
                createdAt: '',
                updatedAt: '',
                geologiaShapeFile: null,
                geometryList: null
            }
        };
        check();

        this.loadShapes = this.loadShapes.bind(this);
        this.loadZipfile = this.loadZipfile.bind(this);
        this.process = this.process.bind(this);
    }

    process(requestList, index, length) {
        let inicio = performance.now();
        let fim = 0;
        let diff = 0;
        let tempo = 0;
        let tempoRestante = "";
        // console.log("inicio: " + inicio);
        updateGeologiaShapeFile(requestList[index])
            .then(obj => {
                if (obj !== null && obj !== undefined) {
                    if (obj.erros === null || obj.erros === undefined || obj.erros.length === 0) {
                        contGeologias += requestList[index].geologiaList.length;
                        let processingStatus = (contGeologias / (totalGeologias + 1)) * 100;

                        fim = performance.now();
                        diff = fim - inicio;
                        tempo = diff * (((totalGeologias + 1) - contGeologias) / LIMITE);
                        tempoRestante = util.formatMiliseconds(tempo);

                        // console.log("fim: " + fim);
                        // console.log("diff: " + diff);
                        // console.log("tempo total em milissegundos: " + tempo);
                        // console.log("tempoRestante: " + tempoRestante);

                        this.setState({ processingStatus: processingStatus.toFixed(2), tempoRestante });

                        if (index === length) {
                            this.props.updateTable(obj, this.props.t('forms.dataUpdateSuccess'));
                            setTimeout(
                                () => this.props.updateTable(false),
                                1000
                            );
                        } else {
                            if (!this.state.canceled) {
                                this.process(requestList, index + 1, length);
                            }
                        }

                    } else {
                        this.setState({ clicked: false });
                        //console.log(obj.erros);
                    }
                } else {
                    this.setState({ clicked: false });
                    if (obj.errors === undefined) {
                        this.show('danger', this.props.t('forms.dataUpdateError'));
                    } else {
                        this.show('danger', obj.errors[0].defaultMessage);
                    }
                }
            });
    }

    handleSubmit(e) {
        if (this.state.next) {
            // this.setCidades();
            // this.setStates();
            this.setCidadesOrdered();
        } else {
            this.setState({ clicked: true });
            let requestList = [];

            totalGeologias = geologias2.length - 1;
            contGeologias = -1;
            while (contGeologias < totalGeologias) {
                let request = {
                    geologiaList: []
                };
                if (contGeologias < 0) {
                    contGeologias++;
                    request.geologiaList.push(geologias2[contGeologias]);
                } else {
                    for (let g = 0; g < LIMITE; g++) {
                        contGeologias++;
                        request.geologiaList.push(geologias2[contGeologias]);
                        if (contGeologias + 1 > totalGeologias) {
                            break;
                        }
                    }
                }
                requestList.push(request);
            }
            contGeologias = 0;
            // console.log(requestList);
            this.process(requestList, 0, requestList.length - 1);
        }
    }

    setStates() {
        if (geologias2 !== null && geologias2 !== undefined && geologias2.length > 0) {
            cidadesFiles = new Map();
            let total = geologias2.length;
            //console.log("Cidades não encontradas: ");
            for (let i = 0; i < total; i++) {
                let cidadeEstado = null;
                if (cidadesFiles.get(geologias2[i].geologiaShapeFile.filename) !== null &&
                    cidadesFiles.get(geologias2[i].geologiaShapeFile.filename) !== undefined) {
                    cidadeEstado = cidadesFiles.get(geologias2[i].geologiaShapeFile.filename);
                } else {
                    cidadeEstado = this.getStates(geologias2[i].geologiaShapeFile);
                    if (cidadeEstado.cidade !== null) {
                        cidadesFiles.set(geologias2[i].geologiaShapeFile.filename, cidadeEstado);
                    }
                }
                if (cidadeEstado !== null && cidadeEstado.cidade !== null) {
                    geologias2[i].geometryList[0].estado = cidadeEstado.estado;
                    geologias2[i].geologiaShapeFile.estado = cidadeEstado.estado;

                } else {
                    console.log(" não encontrado: " + geologias2[i].geologiaShapeFile.filename);
                }
                let processingStatus = ((i + 1) / total) * 100;
                this.setState({ processingStatus: processingStatus.toFixed(2) });
            }
            setTimeout(
                () => this.setState({ processingStatus: 0, processingStatusInfo: this.state.processingStatusInfo + 1 }),
                1000
            );
        }
        console.log(geologias2);
        this.setState({ next: false });
    }

    setCidades() {
        // console.log("setCidades");
        if (geologias2 !== null && geologias2 !== undefined && geologias2.length > 0) {
            cidadesFiles = new Map();
            let total = geologias2.length;
            //console.log("Cidades não encontradas: ");
            for (let i = 0; i < total; i++) {
                let cidadeEstado = null;
                if (cidadesFiles.get(geologias2[i].geologiaShapeFile.name) !== null &&
                    cidadesFiles.get(geologias2[i].geologiaShapeFile.name) !== undefined) {
                    cidadeEstado = cidadesFiles.get(geologias2[i].geologiaShapeFile.name);
                } else {
                    cidadeEstado = this.getCidades(geologias2[i].geologiaShapeFile);
                    if (cidadeEstado.cidade !== null) {
                        cidadesFiles.set(geologias2[i].geologiaShapeFile.name, cidadeEstado);
                    }
                }
                if (cidadeEstado !== null && cidadeEstado.cidade !== null) {
                    geologias2[i].geometryList[0].cidade = cidadeEstado.cidade;
                    geologias2[i].geometryList[0].estado = cidadeEstado.estado;

                    geologias2[i].geologiaShapeFile.cidade = cidadeEstado.cidade;
                    geologias2[i].geologiaShapeFile.estado = cidadeEstado.estado;

                    // console.log(geologias2[i].geologiaShapeFile.filename + ", " + geologias2[i].geologiaShapeFile.name + ", " + geologias2[i].geologiaShapeFile.cidade.name);
                } else {
                    console.log(" não encontrado: " + geologias2[i].geologiaShapeFile.name);
                }
                let processingStatus = ((i + 1) / total) * 100;
                this.setState({ processingStatus: processingStatus.toFixed(2) });
            }
            setTimeout(
                () => this.setState({ processingStatus: 0, processingStatusInfo: this.state.processingStatusInfo + 1 }),
                1000
            );
        }
        console.log(geologias2);
        this.setState({ next: false });
    }

    setCidadesOrdered() {
        // console.log("setCidades");
        if (geologias2 !== null && geologias2 !== undefined && geologias2.length > 0) {
            cidadesFiles = new Map();
            let total = geologias2.length;
            // console.log("setCidadesOrdered - total: " + total);
            for (let i = 0; i < total; i++) {
                let cidadeEstado = null;

                // console.log("geologias2[i].geologiaShapeFile.name:");
                // console.log(geologias2[i].geologiaShapeFile.name);

                if (cidadesFiles.get(geologias2[i].geologiaShapeFile.name) !== null &&
                    cidadesFiles.get(geologias2[i].geologiaShapeFile.name) !== undefined) {
                    cidadeEstado = cidadesFiles.get(geologias2[i].geologiaShapeFile.name);
                } else {
                    cidadeEstado = this.getCidadesOrdered(geologias2[i].geologiaShapeFile);
                    if (cidadeEstado.cidade !== null) {
                        cidadesFiles.set(geologias2[i].geologiaShapeFile.name, cidadeEstado);
                    }
                }
                if (cidadeEstado !== null && cidadeEstado.cidade !== null) {
                    geologias2[i].geometryList[0].cidade = cidadeEstado.cidade;
                    geologias2[i].geometryList[0].estado = cidadeEstado.estado;

                    geologias2[i].geologiaShapeFile.cidade = cidadeEstado.cidade;
                    geologias2[i].geologiaShapeFile.estado = cidadeEstado.estado;

                    // console.log("CidadeEstado id: " + geologias2[i].geologiaShapeFile.name);
                    // console.log(cidadeEstado);
                    // console.log(cidadeEstado.cidade.name);
                    // if(cidadeEstado.cidade.id == 3243 || cidadeEstado.cidade.name == "Fernando de Noronha"){
                    //     console.log(i);
                    // }
                } else {
                    console.log(" não encontrado: " + geologias2[i].geologiaShapeFile.name);
                }
                let processingStatus = ((i + 1) / total) * 100;
                this.setState({ processingStatus: processingStatus.toFixed(2) });
            }
            setTimeout(
                () => this.setState({ processingStatus: 0, processingStatusInfo: this.state.processingStatusInfo + 1 }),
                1000
            );
        }
        console.log(geologias2);
        this.setState({ next: false });
    }

    getStates(file) {
        // console.log("getCidades");
        let cidadeEstado = {
            cidade: null,
            estado: null
        }
        if (file.cidade != null && file.cidade != undefined && file.cidade.id > 0 &&
            file.estado != null && file.estado != undefined && file.estado.id > 0) {
            // console.log(file);
            cidadeEstado = {
                cidade: file.cidade,
                estado: file.estado
            }
        } else {
            let ce = [];
            let name = file.filename.substring(0, 2);
            let city = this.state.cidades.get(name.toLowerCase());//ba
            // console.log(name);
            // console.log(city);
            try {
                cidadeEstado = {
                    cidade: city,
                    estado: city.estado
                }
            } catch {
                console.log(name.toLowerCase());
            }
        }
        return cidadeEstado;
    }

    getCidades(file) {
        // console.log("getCidades");
        let cidadeEstado = {
            cidade: null,
            estado: null
        }
        if (file.cidade != null && file.cidade != undefined && file.cidade.id > 0 &&
            file.estado != null && file.estado != undefined && file.estado.id > 0) {
            // console.log(file);
            cidadeEstado = {
                cidade: file.cidade,
                estado: file.estado
            }
        } else {
            let ce = [];
            let name = file.name.substring(0, 2) + "#" + file.name.substring(3);
            ce = name.split("#");
            name = ce[0] + "-" + util.getTextNormalized(ce[1]);//ba-ibiassuce.shp
            let city = this.state.cidades.get(name.toLowerCase());//ba-ibiassuce
            // console.log(name);
            // console.log(city);
            try {
                cidadeEstado = {
                    cidade: city,
                    estado: city.estado
                }
            } catch {
                console.log(name.toLowerCase());
            }
        }
        return cidadeEstado;
    }

    getCidadesOrdered(file) {
        // console.log("getCidadesOrdered");
        let cidadeEstado = {
            cidade: null,
            estado: null
        }
        if (file.cidade != null && file.cidade != undefined && file.cidade.id > 0 &&
            file.estado != null && file.estado != undefined && file.estado.id > 0) {
            // console.log("file.cidade exists:");  
            // console.log(file);
            cidadeEstado = {
                cidade: file.cidade,
                estado: file.estado
            }
        } else {
            let filename = file.filename.substring(0, 2);
            let name = file.name;
            //geologia_geo_Clip40        616 335
            //geologia_geo_Clip0
            //geologia_geo_Clip40
            //geologia_geo_Clip416
            filename = filename + "-" + name.substr(name.indexOf("Clip")+4);//ba-0
            let city = this.state.cidades.get(filename.toLowerCase());//ba-ibiassuce
            //  console.log(filename);
            //  console.log(city.name);
            try {
                cidadeEstado = {
                    cidade: city,
                    estado: city.estado
                }
            } catch {
                console.log(filename.toLowerCase());
            }
        }
        return cidadeEstado;
    }

    loadShapes() {
        //this.loadFileNames("g");
        //this.loadFileNames("r");
        let total = this.state.files.length;
        if (total > 0) {
            for (let i = 0; i < total; i++) {
                this.loadZipfile(this.state.files[i]);

                let processingStatus = ((i + 1) / total) * 100;
                this.setState({ carregarShapes: false, processingStatus: processingStatus.toFixed(2) });
            }
            setTimeout(
                () => this.setState({ processingStatus: 0, processingStatusInfo: this.state.processingStatusInfo + 1 }),
                1000
            );
        }
    }

    loadZipfile(file) {
        let path = rootGeologias.concat(file.name).concat(".zip");
        try {
            shp(path).then(function (shapes) {
                console.log("shapes:");
                console.log(shapes);
                let list = [];
                if (shapes.length != undefined && shapes.length != null && shapes.length > 0) {
                    list = shapes;
                } else {
                    list.push(shapes);
                }
                //console.log(index);
                //console.log(list);
                //console.log(list.length);

                let totalFeatures = 0;
                let filename = "";
                for (let dta = 0; dta < list.length; dta++) {
                    let data = list[dta];
                    filename = data.fileName.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
                    totalFeatures = data.features.length;
                    let geologiaParsed = null;

                    // console.log(data);
                    // console.log(filename);
                    // console.log(totalFeatures);

                    for (let i = 0; i < totalFeatures; i++) {
                        let geometry = {
                            id: '',
                            simb1000: '',
                            cidade: null,
                            estado: null,
                            color: '',
                            colorRGB: '',
                            status: "ATIVO",
                            deleted: false,
                            bbox: null,
                            coordinates: null,
                            coordinatesMulti: null,
                            bboxList: [],
                            coordinatesList: [],
                            coordinatesMultiList: []
                        };

                        let bboxList = data.features[i].geometry.bbox;
                        if (bboxList != null && bboxList != undefined && bboxList.length > 0) {
                            for (let m = 0; m < bboxList.length; m += 2) {
                                geometry.bboxList.push({
                                    lat: bboxList[(m + 1)],
                                    lng: bboxList[m]
                                });
                            }
                            //console.log(data.features[i].properties.SIMB_1000 + " - " + bboxList);
                        }
                        //console.log(bboxList);

                        let type = data.features[i].geometry.type;
                        let coordinatesList = data.features[i].geometry.coordinates;
                        if (coordinatesList != null && coordinatesList != undefined && coordinatesList.length > 0) {
                            if (type === "Polygon") {
                                for (let j = 0; j < coordinatesList.length; j++) {
                                    let coordinates = coordinatesList[j];
                                    for (let m = 0; m < coordinates.length; m++) {
                                        geometry.coordinatesList.push({
                                            lat: coordinates[m][1],
                                            lng: coordinates[m][0]
                                        });
                                    }
                                }
                            } else if (type === "MultiPolygon") {
                                for (let j = 0; j < coordinatesList.length; j++) {
                                    let coordinatesAux = coordinatesList[j];
                                    for(let c = 0; c < coordinatesAux.length; c++){
                                        let coordinates = coordinatesAux[c];
                                        let coordList = [];
                                        for(let m = 0; m < coordinates.length; m++){
                                            coordList.push({
                                            lat: coordinates[m][1],
                                            lng: coordinates[m][0]
                                            });
                                        }
                                        geometry.coordinatesMultiList.push(coordList);
                                    }
                                }
                            }
                        }

                        let properties = data.features[i].properties;
                        if (properties != null && properties != undefined) {
                            geologiaParsed = {
                                simb1000: properties.SIMB_1000 || properties.SIGLA_UNID,
                                agrLITD: properties.AGR_LITD,
                                classe1: properties.CLASSE1 || properties.CLASSE_ROC,
                                classe2: properties.CLASSE2 || properties.CLASSE_R_1,
                                clIdLITO: properties.CL_ID_LITO,
                                codUnMET: properties.COD_UN_MET,
                                codUnPLO: properties.COD_UN_PLO,
                                eonIdMAX: properties.EON_ID_MAX || properties.EON_IDAD_M,
                                eonIdMIN: properties.EON_ID_MIN || properties.EON_IDAD_1,
                                epcIdMAX: properties.EPC_ID_MAX || properties.EPOCA_MAX,
                                epcIdMIN: properties.EPC_ID_MIN || properties.EPOCA_MIN,
                                eraIdMAX: properties.ERA_ID_MAX || properties.ERA_MAXIMA,
                                eraIdMIN: properties.ERA_ID_MIN || properties.ERA_MAXIMA,
                                errIdMAX: properties.ERR_ID_MAX || properties.ERRO_MAX,
                                errIdMIN: properties.ERR_ID_MIN || properties.ERRO_MIN,
                                hierarquia: properties.HIERARQUIA,
                                idadeMAX: properties.IDADE_MAX,
                                idadeMIN: properties.IDADE_MIN,
                                legMAPA1: properties.LEG_MAPA1,
                                legMAPA2: properties.LEG_MAPA2,
                                lito1: properties.LITO1 || properties.LITOTIPO1,
                                lito2: properties.LITO2 || properties.LITOTIPO1,
                                metodoMAX: properties.METODO_MAX || properties.METODO_GEO,
                                metodoMIN: properties.METODO_MIN || properties.METODO_G_1,
                                nomeUNID: properties.NOME_UNID || properties.NOME_UNIDA,
                                provincia: properties.PROVINCIA,
                                qdeInMAX: properties.QDE_IN_MAX || properties.QLDE_INFER,
                                qdeInMIN: properties.QDE_IN_MIN || properties.QLDE_INF_1,
                                simbNEOP: properties.SIMB_NEOP,
                                sisGcMAX: properties.SIS_GC_MAX || properties.SISTEMA_GE,
                                sisGcMIN: properties.SIS_GC_MIN || properties.SISTEMA__1,
                                sisIdMAX: properties.SIS_ID_MAX || properties.PERIODO_MA,
                                sisIdMIN: properties.SIS_ID_MIN || properties.PERIODO_MI,
                                subClasse1: properties.SUBCLASSE1 || properties.BB_SUBCLAS,
                                subClasse2: properties.SUBCLASSE2 || properties.BB_SUBCL_1,
                                description: (properties.SISTSEDIME ? properties.SISTSEDIME + (properties.TIPO_DEPOS ? '. ' + properties.TIPO_DEPOS : '') : (properties.TIPO_DEPOS ? properties.TIPO_DEPOS : '')),
                                photo: '',
                                bibliografia: '',
                                color: '',
                                colorRGB: '',
                                status: "ATIVO",
                                deleted: false,
                                createdAt: '',
                                updatedAt: ''
                            };
                            geometry.simb1000 = geologiaParsed.simb1000 || 'Não Informado';
                            // geometry.color = geologiaParsed.color
                            // geometry.colorRGB = geologiaParsed.colorRGB;
                            geometry.status = geologiaParsed.status;
                            geometry.deleted = geologiaParsed.deleted;
                        }
                        //montou a geologia

                        geologiaParsed.geologiaShapeFile = {
                            cidade: file.cidade,
                            createdAt: file.createdAt,
                            deleted: file.deleted,
                            estado: file.estado,
                            extension: file.extension,
                            id: file.id,
                            name: filename,
                            filename: file.name + ".zip",
                            geologias: totalFeatures,
                            geologiasLidas: 0,
                            size: file.size,
                            statusLoad: file.statusLoad,
                            type: file.type,
                            updatedAt: file.updatedAt,
                            start: false
                        }
                        //console.log(geologiaParsed.geologiaShapeFile);
                        geologiaParsed.geometryList = [];
                        geologiaParsed.geometryList.push(geometry);

                        geologias2.push(geologiaParsed);
                    }
                }
                //console.log("geologias:");
                //console.log(geologias2);
            });
        } catch (err) {
            console.log(err);
        }
    }

    loadData(files, cidades) {
        if (files !== undefined && files !== null && files.length > 0 &&
            cidades !== undefined && cidades !== null && cidades.size > 0) {
            this.setState({
                files,
                cidades
            }, () => { });
        }
    }

    countPolygon(type, list) {
        let total = 0;
        if (type === "P") {
            total = list.length;
        } else {
            for (let i = 0; i < list.length; i++) {
                total += list[i].length;
            }
        }
        return total;
    }

    componentDidMount() {
        checkKey("MENU_GEOLOGY_SHP_CITY_PROCESSING");

        const { files, cidades } = this.props;
        this.loadData(files, cidades);
        NotificationSystem.newInstance({ style: { top: 65 } }, n => notificationTC = n);
    }

    componentDidUpdate(props, state) {
        if (props.files !== this.props.files || props.cidades !== this.props.cidades) {
            this.loadData(this.props.files, this.props.cidades);
        }
    }

    componentWillUnmount() {
        notificationTC.destroy();
    }

    clear(canceled) {
        const data = { ...this.state.data }
        data['id'] = '';
        data['simb1000'] = '';
        data['agrLITD'] = '';
        data['classe1'] = '';
        data['classe2'] = '';
        data['clIdLITO'] = '';
        data['codUnMET'] = '';
        data['codUnPLO'] = '';
        data['eonIdMAX'] = '';
        data['eonIdMIN'] = '';
        data['epcIdMAX'] = '';
        data['epcIdMIN'] = '';
        data['eraIdMAX'] = '';
        data['eraIdMIN'] = '';
        data['errIdMAX'] = '';
        data['errIdMIN'] = '';
        data['hierarquia'] = '';
        data['idadeMAX'] = '';
        data['idadeMIN'] = '';
        data['legMAPA1'] = '';
        data['legMAPA2'] = '';
        data['lito1'] = '';
        data['lito2'] = '';
        data['metodoMAX'] = '';
        data['metodoMIN'] = '';
        data['nomeUNID'] = '';
        data['provincia'] = '';
        data['qdeInMAX'] = '';
        data['qdeInMIN'] = '';
        data['simbNEOP'] = '';
        data['sisGcMAX'] = '';
        data['sisGcMIN'] = '';
        data['sisIdMAX'] = '';
        data['sisIdMIN'] = '';
        data['subClasse1'] = '';
        data['subClasse2'] = '';
        data['description'] = '';
        data['photo'] = false;
        data['bibliografia'] = '';
        data['color'] = '#87CEFA';
        data['colorRGB'] = { r: 135, g: 206, b: 250, a: 1 };
        data['status'] = '';
        data['deleted'] = '';
        data['createdAt'] = '';
        data['updatedAt'] = '';
        data['name'] = '';
        data['geologiaShapeFile'] = null;
        data['geometryList'] = null;
        this.setState({
            data,
            cidades: {},
            files: [],
            geologies: [],
            canceled
        }, () => { });
    }

    cancel(event) {
        this.clear(true);
        this.props.updateTable(false);
    }

    show = (color, message) => {
        return notificationTC.notice({
            content: <FullWideNotification
                color={color}
                message={message}
            />,
            duration: 3,
            closable: true,
            style: { top: 0, left: 0 },
            className: `full ltr-support`,
        });
    };

    render() {
        const { t } = this.props;
        const { files, carregarShapes, clicked, processingStatus, processingStatusInfo, tempoRestante } = this.state;

        let geologiaShapeFile = [];
        if (this.state.next) {
            let total = files.length;
            if (total > 0) {
                for (let i = 0; i < total; i++) {
                    geologiaShapeFile.push(
                        <div key={"divshapes_" + i} className='form__form-inline' style={{ width: '100%', borderBottom: '1px solid #cccccc' }}>
                            <label
                                key={"labelshapes_" + i}
                                style={{ margin: 0, width: '100%' }}>
                                {files[i].name}
                            </label>
                            <label
                                key={"labelshapes2_" + i}
                                style={{ margin: 0, }}>
                                {t('forms.geologias')}
                            </label>
                        </div>
                    );
                }
            }
        } else {
            let exists = false;
            shapeFile = [];
            let total = geologias2.length;
            let maxSimbs = 20;
            if (total > 0) {
                for (let i = 0; i < total; i++) {
                    //console.log("ini for name => " + geologias2[i].geologiaShapeFile.name);
                    if (shapeFile.length === 0) {
                        let shp = {
                            name: geologias2[i].geologiaShapeFile.name,
                            simb1000: [],
                            simbs: [],
                            full: false
                        };
                        geologias2[i].geologiaShapeFile.start = true;
                        //console.log("ini =>  " + shp.name);
                        if (geologias2[i].geometryList[0].coordinatesList.length > 0) {
                            shp.simb1000.push(geologias2[i].simb1000 + " (Polygon coords: " + this.countPolygon("P", geologias2[i].geometryList[0].coordinatesList) + ")");
                        } else {
                            shp.simb1000.push(geologias2[i].simb1000 + " (MultiPolygon coords: " + this.countPolygon("M", geologias2[i].geometryList[0].coordinatesMultiList) + ")");
                        }
                        shp.simbs.push(geologias2[i].simb1000);
                        shapeFile.push(shp);
                    } else {
                        //console.log("demais =>  " + geologias2[i].geologiaShapeFile.name);
                        exists = false;
                        for (let j = 0; j < shapeFile.length; j++) {
                            //console.log(geologias2[i].geologiaShapeFile.name + " === " + shapeFile[j].name);
                            if (geologias2[i].geologiaShapeFile.name === shapeFile[j].name) {
                                exists = true;
                                //console.log("Igual");
                                if (shapeFile[j].simb1000.length < maxSimbs) {
                                    if (geologias2[i].geometryList[0].coordinatesList.length > 0) {
                                        shapeFile[j].simb1000.push(geologias2[i].simb1000 + " (Polygon coords: " + this.countPolygon("P", geologias2[i].geometryList[0].coordinatesList) + ")");
                                    } else {
                                        shapeFile[j].simb1000.push(geologias2[i].simb1000 + " (MultiPolygon coords: " + this.countPolygon("M", geologias2[i].geometryList[0].coordinatesMultiList) + ")");
                                    }
                                    if (!shapeFile[j].simbs.includes(geologias2[i].simb1000)) {
                                        shapeFile[j].simbs.push(geologias2[i].simb1000);
                                    }
                                    shapeFile[j].simb1000 = shapeFile[j].simb1000.sort((a, b) => (a > b) ? 1 : -1);
                                } else {
                                    if (!shapeFile[j].full) {
                                        shapeFile[j].simb1000.push("...");
                                        shapeFile[j].full = true;
                                    }
                                }
                                break;
                            }
                        }
                        //console.log("saiu do for => " + geologias2[i].geologiaShapeFile.name + " === " + exists);
                        if (!exists) {
                            //console.log("não existe => " + geologias2[i].geologiaShapeFile.name);
                            let shp = {
                                name: geologias2[i].geologiaShapeFile.name,
                                simb1000: [],
                                simbs: [],
                                full: false
                            }
                            geologias2[i].geologiaShapeFile.start = true;
                            //console.log("novo =>  " + shp.name);
                            if (geologias2[i].geometryList[0].coordinatesList.length > 0) {
                                shp.simb1000.push(geologias2[i].simb1000 + " (Polygon coords: " + this.countPolygon("P", geologias2[i].geometryList[0].coordinatesList) + ")");
                            } else {
                                shp.simb1000.push(geologias2[i].simb1000 + " (MultiPolygon coords: " + this.countPolygon("M", geologias2[i].geometryList[0].coordinatesMultiList) + ")");
                            }
                            shp.simbs.push(geologias2[i].simb1000);
                            shapeFile.push(shp);
                        }
                    }
                }

                for (let i = 0; i < shapeFile.length; i++) {
                    let simbs = [];
                    for (let j = 0; j < shapeFile[i].simb1000.length; j++) {
                        simbs.push(
                            <div key={"labelshapesdiv_" + i + "_" + j} className='form__form-inline'
                                style={{
                                    width: 'auto', backgroundColor: 'rgb(190 255 190 / 35%)', border: '1px solid',
                                    borderColor: 'rgb(36 140 36 / 35%)', paddingLeft: '3px', paddingRight: '3px', marginRight: '10px', marginBottom: '10px'
                                }}>
                                <label
                                    key={"labelshapes2_" + i}
                                    style={{ margin: 0, }}>
                                    {shapeFile[i].simb1000[j]}
                                </label>
                            </div>
                        );
                    }

                    geologiaShapeFile.push(
                        <div key={"divshapes_" + i} className="form__form-inline"
                            style={{ height: 'auto', width: '100%', borderBottom: '1px solid #cccccc' }}>
                            <label
                                key={"labelshapes_" + i}
                                style={{ margin: 0, width: '100%' }}>
                                {shapeFile[i].name + ": " + shapeFile[i].simb1000.length + " Shapes e " + shapeFile[i].simbs.length + " Geologias"}
                            </label>
                            <div key={"divshapes_simbs" + i} className="form__form-group-field"
                                style={{ width: '100%', display: 'flow-root', flexWrap: 'wrap' }}>
                                {simbs}
                            </div>
                        </div>
                    );
                }
            }
        }

        return (
            <Col md={12} lg={12}>
                <Card>
                    <CardBody>
                        <div className="form__form-group">
                            <h3 className="page-subhead subhead">{t('forms.toProcess')}</h3>
                        </div>
                        <div className="form">

                            <div className="form__form-group">
                                <span title={t('forms.requiredField')} className="form__form-group-label">
                                    {t('forms.processingStatus') + " - " + t('forms.processingStatusInfo_' + processingStatusInfo) + ": " + processingStatus + " % (" + t('forms.timeLeft') + ": " + tempoRestante + ")"}
                                </span>
                                <div key="div1" className="progress-wrap progress-wrap--big">
                                    <Progress key="progress1" animated value={processingStatus} />
                                </div>
                                <div className="form__form-group-field"
                                    style={{
                                        border: '1px solid #CCCCCC', height: '160px', overflowY: 'auto',
                                        display: 'flow-root', flexWrap: 'wrap', paddingTop: '5px', paddingLeft: '5px'
                                    }}>

                                    {geologiaShapeFile}

                                </div>
                            </div>

                            <ButtonToolbar className="form__button-toolbar">
                                <Button color="primary" type="submit"
                                    onClick={e => this.loadShapes()}
                                    disabled={!carregarShapes}>
                                    {t('forms.loadShapes')}
                                </Button>
                                <Button color="primary" type="submit"
                                    onClick={e => this.handleSubmit(e)}
                                    disabled={carregarShapes || clicked}>
                                    {this.state.next ? t('forms.synchronize') : t('forms.save')}
                                </Button>
                                <Button type="button" onClick={e => this.cancel(e)}>
                                    {t('forms.cancel')}
                                </Button>
                            </ButtonToolbar>
                        </div>
                    </CardBody>
                </Card>
            </Col>
        );
    }
}

export default withTranslation('common')(CrudEdit);